import React, { useState, useEffect, useMemo } from 'react';
import Cookies from 'universal-cookie';
import Modal from 'react-modal';
import { IconClose } from '../../assets/svgs-index';
import { Helper } from '../../core/services/helper/helper.service';
import { CookiesLabels } from '../../assets/labels/cookies.labels';
import CookieDetails from './CookieDetails';
import './ModalCookieBanner.scss';

interface ModalCookieBannerProps {
    updateAnalyticCookies: (value: boolean) => void;
  }

const ModalCookieBanner: React.FC<ModalCookieBannerProps> = ({ updateAnalyticCookies }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [detailsModalIsOpen, setDetailsModalIsOpen] = useState(false);
    const [analyticsCookies, setAnalyticsCookies] = useState(true);
    const cookies = useMemo(() => new Cookies(), []);

    useEffect(() => {
        const acceptedCookies = cookies.get('acceptedNecessaryCookies');
        if (!acceptedCookies) {
            setModalIsOpen(true);
        }
    }, [cookies]);

    // Adjust height on resize and detailsModalIsOpen changes
    useEffect(() => {
        if (detailsModalIsOpen) {
            setTimeout(() => adjustDetailsContainerHeight(), 50);

            const handleAdjustHeight = () => {
                adjustDetailsContainerHeight();
            };
            window.addEventListener('resize', handleAdjustHeight);
            return () => {
                window.removeEventListener('resize', handleAdjustHeight);
            };
        }
    // eslint-disable-next-line 
    }, [detailsModalIsOpen]);

    const handleAcceptCookies = () => {
        Helper.setCookie('acceptedNecessaryCookies', 'true');
        if (analyticsCookies) {
            Helper.setCookie('acceptedAnalyticsCookies', 'true');
            updateAnalyticCookies(true);
        }
        setModalIsOpen(false);
    };

    const handleLearnMore = () => {
        setDetailsModalIsOpen(true);
    };

    const removeTabIndex = (contentElement: HTMLElement | null) => {
        if (contentElement) {
            contentElement.removeAttribute('tabindex');
        }
    };

    const handleAnalyticsSwitch = () => {
        setAnalyticsCookies(!analyticsCookies);
    };

    const adjustDetailsContainerHeight = () => {
        if (!detailsModalIsOpen) {
            return;
        }
        const contentElement = document.querySelector('#detailsModalResume') as HTMLElement | null;
        const detailsContainer = document.querySelector('#detailsModalDetails') as HTMLElement | null;
        if (!contentElement || !detailsContainer) {
            return;
        }
        const contentHeight = contentElement.offsetHeight;
        const viewportHeight = window.innerHeight;
        const calculatedHeight = viewportHeight - contentHeight - 72;
        detailsContainer.style.setProperty('height', `${calculatedHeight}px`, 'important');
    };


    return (
        <>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={handleAcceptCookies}
                shouldCloseOnOverlayClick={false}
                className="modalBanner-modal"
                overlayClassName="modalBanner-overlay"
                contentRef={removeTabIndex}
            >
                {detailsModalIsOpen && (
                    <>
                        <div id="detailsModalDetails" className="modalBanner-detailsContainer mt-3">
                            <div className="modalBanner-closeButton" onClick={() => setDetailsModalIsOpen(false)}>
                                <img src={IconClose} alt="icon-modal-close" />
                            </div>
                            <div className="mb-0">
                                <CookieDetails />
                            </div>
                        </div>
                        <div id="detailsModalResume" className="modalBanner-content topShadow">
                            <div className="modalBanner-switches mt-1">
                                <div className="switch-option">
                                    <label className="switch-label p-2">Cookies Analíticos</label>
                                    <div className="switch-container" onClick={handleAnalyticsSwitch}>
                                        <div className={`switch ${analyticsCookies ? 'on' : 'off'}`} />
                                    </div>
                                </div>
                                <div className="switch-option">
                                    <label className="switch-label disabled p-2">Cookies de Funcionamento</label>
                                    <div className="switch-container disabled">
                                        <div className="switch on disabled" />
                                    </div>

                                </div>
                            </div>
                            <div className="modalBanner-buttons">
                                <button className='cta-button-primary w-75 mt-3' type="button" onClick={handleAcceptCookies}>
                                    Gravar Seleção
                                </button>
                            </div>
                        </div>
                    </>
                )}
                {!detailsModalIsOpen && (
                    <div className="modalBanner-content">
                        <p className='mb-1'>
                            {Helper.getCookiesMessage()}
                        </p>
                        <div className='link-container mb-3' role={'button'} onClick={handleLearnMore}>
                            {CookiesLabels.learnMoreLink}
                        </div>
                        <div className="modalBanner-buttons">
                            <button className='cta-button-primary w-100' type="button" onClick={handleAcceptCookies}>
                                OK
                            </button>
                            <button className='cta-button-secondary w-100' type="button" onClick={handleLearnMore}>
                                Mais opções
                            </button>
                        </div>
                    </div>
                )}
            </Modal>
        </>
    );
};

export default ModalCookieBanner;